import translation from 'translation';
import { magicNumbers } from 'utils';

export const mapToFilterOption = (platform) => {
  const { t } = translation;
  const options = {
    news: {
      id: 'newsAgencies',
      usernameField: 'url',
      usernameIcon: '',
      subTitle: '',
      subTitleField: '',
      color: '#199DA3',
      icon: 'ri-global-line',
      avatarClass: 'w-65',
      path: '/search/api/v1/search',
      params: {
        api_path: '/news/agencies',
      },
    },
    newspaper: {
      id: 'newspaperAgencies',
      usernameField: 'url',
      usernameIcon: '',
      subTitle: '',
      subTitleField: '',
      color: '#199DA3',
      icon: 'ri-newspaper-line',
      avatarClass: 'w-65',
      path: '/search/api/v1/search',
      params: {
        api_path: '/newspaper/agencies',
      },
    },
    kiosk: {
      id: 'newspaperAgencies',
      usernameField: 'url',
      usernameIcon: '',
      subTitle: '',
      subTitleField: '',
      color: '#0F7173',
      icon: 'ri-newspaper-line',
      avatarClass: 'w-65',
      path: '/search/api/v1/search',
      params: {
        api_path: '/newspaper/agencies',
      },
    },
    instagram: {
      id: 'instagramUsers',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:followerCount'),
      subTitleField: 'follower_count',
      color: '#C63C73',
      icon: 'ri-instagram-line',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/users',
        sort: 'follower_count',
        want_vip_flag: 1,
      },
    },
    instagramComment: {
      id: 'instagramUsers',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:followerCount'),
      subTitleField: 'follower_count',
      color: '#9CAEBB',
      icon: 'ri-instagram_comment-line',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/instagram/users',
        sort: 'follower_count',
        want_vip_flag: 1,
      },
    },
    twitter: {
      id: 'twitterUsers',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:followerCount'),
      subTitleField: 'follower_count',
      color: '#5AD1F6',
      icon: 'ri-twitter-line',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/twitter/users',
        sort: 'follower_count',
      },
    },
    telegram: {
      id: 'telegramChannels',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:memberCount'),
      subTitleField: 'member_count',
      color: '#32AADD',
      icon: 'ri-telegram-line',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/telegram/channels',
        sort: 'member_count',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
      },
    },
    nativePlatforms: {
      id: 'nativePlatformsChannels',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:memberCount'),
      subTitleField: 'member_count',
      color: '#199DA3',
      icon: 'ri-message-3-line',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/channels',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
        sort: 'member_count',
      },
    },
    linkedin: {
      id: 'linkedinUsers',
      usernameField: 'username',
      usernameIcon: '',
      subTitle: '',
      subTitleField: '',
      color: '#0a66c2',
      icon: 'ri-linkedin-box-line',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/linkedin/users',
      },
    },
    bale: {
      id: 'baleChannels',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:memberCount'),
      subTitleField: 'member_count',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/channels',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
        sort: 'member_count',
      },
    },
    rubika: {
      id: 'rubikaChannels',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:memberCount'),
      subTitleField: 'member_count',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/channels',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
        sort: 'member_count',
      },
    },
    eitaa: {
      id: 'eitaaChannels',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:memberCount'),
      subTitleField: 'member_count',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/iranian-platforms/channels',
        time_duration: magicNumbers.ONE_WEEK_IN_SECONDS,
        sort: 'member_count',
      },
    },
    virasty: {
      id: 'virastyChannels',
      usernameField: 'username',
      usernameIcon: '@',
      subTitle: t('filter:followerCount'),
      subTitleField: 'follower_count',
      iconSrc: 'virasty-line-active',
      avatarClass: '',
      path: '/search/api/v1/search',
      params: {
        api_path: '/virasty/users',
      },
    },
  };

  return options[platform];
};
